
class FormContactDetails extends require('common/helpers/validate') {
   // Validation schema
   get schema() {
      return {
         email: {
            required: true,
            type: 'email'
         },
         mobile: {
            required: true,
            type: 'mobile'
         },
         ecname: {
            required_when: ['ecupdate','yes'],
            type: 'name'
         },
         ecrelation: {
            required_when: ['ecupdate','yes'],
            type: 'alphanumeric'
         },
         ecphone: {
            required_when: ['ecupdate','yes'],
            type: 'phone'
         },
         type: {
            type: 'string'
         },
         ecupdate: {
            type: 'string'
         }
      }
   }

   get messages() {
      return {
         'email': 'msg:email error',
         'mobile.mobile': 'msg:mobile error',
         'mobile.required': 'msg:mobile error',
         'ecname.required_when': 'msg:emergency contact name error',
         'ecrelation.required_when': 'msg:emergency contact relationship error',
         'ecphone.required_when': 'msg:emergency contact phone required error',
         'ecphone.phone': 'msg:emergency contact phone error',
      }
   }
}

module.exports = FormContactDetails
